import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function WhatsappOrdersContent() {
  const { t } = useTranslation();

  return (
    <Stack gap={1} px={2} mt={2}>
      <NotificationRow name="Julien" total="18,70 €" time={t("comingSoon.whatsappOrder.time1", "il y a 3 min")} />
      <NotificationRow name="Sarah" total="24,50 €" time={t("comingSoon.whatsappOrder.time2", "il y a 8 min")} />
    </Stack>
  );
}

function NotificationRow({ name, total, time }: { name: string; total: string; time: string }) {
  const { t } = useTranslation();

  return (
    <Stack direction="row" alignItems="center" gap={1} sx={{ bgcolor: "#f3f3f3", backdropFilter: "blur(15px)", borderRadius: "16px", pl: "9px", pr: "14px", py: "9px" }}>
      <Box component="img" src="/assets/whatsapp.png" alt="" sx={{ width: 38, height: 38 }} />
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
          <Typography fontSize={15} fontWeight={600} color="#222" letterSpacing="-0.3px">Whats App</Typography>
          <Typography fontSize={12} fontWeight={500} color="#3f3f3f" sx={{ opacity: 0.5 }} letterSpacing="-0.24px">{time}</Typography>
        </Stack>
        <Typography fontSize={15} color="#3f3f3f" letterSpacing="-0.75px" noWrap>
          {t("comingSoon.whatsappOrder.notification", "{{name}} ordered • Total: {{total}}", { name, total })}
        </Typography>
      </Stack>
    </Stack>
  );
}
